import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const LegalPage = ({ title, intro = [], sections = [], testid }) => (
  <div className="relative min-h-screen bg-ink-950" data-testid={testid}>
    <Helmet>
      <title>{`${title} - Synaphy`}</title>
      <meta name="description" content={`${title} for synaphy.com - applicable during the Synaphy pre-launch phase.`} />
    </Helmet>
    <div className="absolute left-1/2 top-0 -translate-x-1/2 h-[320px] w-[640px] rounded-full bg-signal-violet/[0.05] blur-[140px] pointer-events-none" />

    <header className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 h-[72px] flex items-center justify-between border-b border-white/5">
      <Link to="/" className="flex items-center gap-3 group" data-testid={`${testid}-logo`} aria-label="Synaphy home">
        <img src="/logo-lockup.png" alt="Synaphy - Intelligence for the physical world" className="h-14 w-auto object-contain drop-shadow-[0_0_18px_rgba(90,150,255,0.35)] transition-transform duration-300 group-hover:scale-105" />
      </Link>
    </header>

    <main className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 pt-16 sm:pt-24 pb-28">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE }}>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-[1.08] text-mist" data-testid={`${testid}-title`}>
          {title}
        </h1>
        {intro.map((p, i) => (
          <p key={i} className="mt-6 text-[15px] leading-relaxed text-steel">
            {p}
          </p>
        ))}

        <div className="mt-14 space-y-12">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${testid}-section-${i + 1}`}>
              <h2 className="font-display text-lg font-semibold tracking-tight text-mist">
                {i + 1}. {s.title}
              </h2>
              {s.paragraphs?.map((p, j) => (
                <p key={j} className="mt-4 text-[15px] leading-relaxed text-steel">
                  {p}
                </p>
              ))}
              {s.list && (
                <ul className="mt-4 space-y-2">
                  {s.list.map((li, j) => (
                    <li key={j} className="flex gap-3 text-[15px] leading-relaxed text-steel">
                      <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-signal-cyan" />
                      <span>{li}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </motion.div>
    </main>
  </div>
);
